module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show"
  }, [_c('divider', [_vm._v("pc page")]), _vm._v(" "), _c('swiper', {
    attrs: {
      "auto": "",
      "height": "210px"
    }
  }, [_c('swiper-item', {
    staticClass: "black"
  }, [_c('img', {
    staticClass: "imgSize",
    attrs: {
      "src": require("../assets/i80NewImage/1.png")
    }
  })]), _vm._v(" "), _c('swiper-item', {
    staticClass: "black"
  }, [_c('img', {
    staticClass: "imgSize",
    attrs: {
      "src": require("../assets/i80NewImage/2.png")
    }
  })]), _vm._v(" "), _c('swiper-item', {
    staticClass: "black"
  }, [_c('img', {
    staticClass: "imgSize",
    attrs: {
      "src": require("../assets/i80NewImage/3.png")
    }
  })])], 1), _vm._v(" "), _c('divider', [_vm._v("mobile page")]), _vm._v(" "), _c('swiper', {
    attrs: {
      "auto": "",
      "height": "600px"
    }
  }, [_c('swiper-item', {
    staticClass: "black"
  }, [_c('img', {
    staticClass: "imgSize",
    attrs: {
      "src": require("../assets/i80MobileImage/1.jpg")
    }
  })]), _vm._v(" "), _c('swiper-item', {
    staticClass: "black"
  }, [_c('img', {
    staticClass: "imgSize",
    attrs: {
      "src": require("../assets/i80MobileImage/2.png")
    }
  })]), _vm._v(" "), _c('swiper-item', {
    staticClass: "black"
  }, [_c('img', {
    staticClass: "imgSize",
    attrs: {
      "src": require("../assets/i80MobileImage/3.png")
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-322c42d7!./~/.1.0.50@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/show.vue
// module id = 91
// module chunks = 0